import React from 'react';
import { Controller, useWatch, type Control } from 'react-hook-form';

import { useTranslation } from 'src/i18n';
import { Field, FieldError, FieldLabel } from 'src/component/ds/ui/field';
import { Input } from 'src/component/ds/ui/input';
import FormSelectField from 'src/component/v2/form/FormSelectField';
import RequiredLabel from 'src/component/v2/form/RequiredLabel';
import { CUSTOM_SERIAL_PORT, SERIAL_PORTS, type ConnectionFormValues } from './addConnectionSchema';

export default function SerialPortField ({ control }: { control: Control<ConnectionFormValues> }) {
  const { t } = useTranslation();
  const serialPort = useWatch({ control, name: 'serial_port' });

  return (
    <>
      <FormSelectField
        control={control}
        name='serial_port'
        label={t('deviceNav.addConnection.serialPort')}
        placeholder={t('deviceNav.addConnection.serialPortPlaceholder')}
        options={[
          ...SERIAL_PORTS.map((port) => ({ value: port, label: port })),
          { value: CUSTOM_SERIAL_PORT, label: t('deviceNav.addConnection.customSerialPortOption') }
        ]}
      />
      {serialPort === CUSTOM_SERIAL_PORT && (
        <Controller
          name='custom_serial_port'
          control={control}
          render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid} className='ds-gap-1'>
              <FieldLabel htmlFor={field.name} weight='normal'>
                <RequiredLabel>{t('deviceNav.addConnection.customSerialPort')}</RequiredLabel>
              </FieldLabel>
              <Input
                {...field}
                id={field.name}
                aria-invalid={fieldState.invalid}
                placeholder={t('deviceNav.addConnection.customSerialPortPlaceholder')}
                autoComplete='off'
              />
              {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            </Field>
          )}
        />
      )}
    </>
  );
}
